export namespace UnitSizerTypes {
  export interface IUnitSizer {
    pageTitle?: string;
    pageDescription?: string;
    theme?: 'light' | 'dark';
    variant?: 'card' | 'carousel';
    unitSizerDetails: TUnitSize[];
    ctaConfig?: TCtaConfig;
  }
  export type TUnitSize = {
    imgUrl: string;
    imgAlt?: string;
    unitSize: string;
    description?: string;
    storableItems?: TStorableItem[];
  };
  export type TStorableItem = {
    item: string;
  };
  export type TCarousel = {
    theme?: 'light' | 'dark';
    selectedIndex: number;
    setSelectedIndex: (e: number) => void;
    unitSizerDetails: TUnitSize[];
  };
  export type TStorableItemList = {
    unitSize: string;
    description?: string;
    storableItems?: TStorableItem[];
  };
  export type TCtaConfig = {
    theme?: 'light' | 'dark' | 'highlighted';
    type?: 'primary' | 'outline' | 'tertiary';
    label: string;
    link: string;
  };
}
